import React, { useState } from 'react'
import { Drawer } from 'antd'
import { useHistory, useParams } from 'react-router-dom'

import { useToggle, usePet, normalizeCase } from '../../modules'

import Receive from '../reusable/receive'
import { EntryFields } from '../reusable/inputs'

const Vitals = ({ onClose }) => {
    const [entry, setEntry] = useState()

    const history = useHistory()
    const { id, document: doc } = useParams()

    const [visible, toggleVisible] = useToggle(true)

    const [{ loading, error }, getEntry] = usePet('singleEntry', { id }, { notify: true, callback: ({ data }) => setEntry(data) })

    const reload = () => {
        setEntry()
        getEntry()
    }

    const [{ loading: compLoading }, completeEntry] = usePet('completeEntry', { id: entry?._id }, { notify: true, callback: (_, notif, ops) => {
        notif('Changes have been saved', ops('success'))
        onClose()
        close()
    }, manual: true, load: { msg: 'Saving changes...' } })

    const close = () => {
        toggleVisible()
        // onClose()
        setTimeout(() => history.goBack(), 300)
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ completeEntry } disabled={ compLoading } className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">{ entry?.filled ? 'Update' : 'Complete' }</button>
                    <button onClick={ close } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width="40%">
            <Receive
                progress
                loading={loading}
                error={error}>
                {
                    entry ?
                    <>
                        <p className="font-extrabold text-3xl mb-0">{ normalizeCase(entry?.ref?.patient?.name?.split(' ')[0] ?? 'Patient')}'s Vitals</p>
                        <p className="text-gray-500 text-xs italic">Please fill out vitals as measured</p>
                        {
                            <EntryFields
                                reload={ reload }
                                entry={ entry }
                                fields={ entry?.item?.fields ?? [] } />
                        }
                    </>
                    : null
                }
            </Receive>
        </Drawer>
    )
}

export default Vitals